import styled from "styled-components"
import padding from "@irati/ui/src/global/padding"
import Button from "@irati/ui/src/Button"
import IconButton from "@irati/ui/src/Button/IconButton"
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton"

export default styled(Button)`
  margin-right: 15px;
`

export const StyledValidationButton = styled(ValidationButton)`
  margin-top: ${padding.base};
`

export const StyledIconButton = styled(IconButton)`
  position: fixed;
`
